<template>
    <div>
        <div>
            <div class="common-search">
                <el-input
                        class="common-el-input"
                        placeholder="输入查询的最近天数"
                        type="number"
                        v-model.number="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
                <el-button type="success" @click="exportFunc">导出</el-button>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="list" height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="IP" align="center" prop="ip" width="180"/>
                <el-table-column label="玩家ID" align="center" prop="userId"/>
            </el-table>
        </div>
    </div>
</template>
<script>
    import {mapMutations, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                list: []
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('dataManage', ['getBringIp']),
            parameterCalibration() {
                if (!this.searchVal) {
                    this.$message.error('请输入查询的最近天数');
                    return false
                } else if (this.searchVal < 1) {
                    this.$message.error('查询天数不能小于1天');
                    return false
                } else if (!Number.isInteger(this.searchVal)) {
                    this.$message.error('查询天数应为整数');
                    return false
                }
                return true
            },
            getList() {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                this.getBringIp({days: this.searchVal}).then(res => {
                    this.list = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/data/manage/takein/ip/export',
                    info: [
                        {name: 'days', value: this.searchVal},
                    ]
                });
            }
        }
    }
</script>